// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5405":"21489d65","6452":"20fbab3b","6850":"5eaff731"}[chunkId] + ".chunk.css";
};